var map = {
	"./blackGold/safeBox/transferToIcon.png": 15120,
	"./brownGold/safeBox/transferToIcon.png": 66058,
	"./darkBlue/safeBox/transferToIcon.png": 50355,
	"./greenYellow/safeBox/transferToIcon.png": 39594,
	"./redGold/safeBox/transferToIcon.png": 9197,
	"./skyBlue/safeBox/transferToIcon.png": 34627,
	"./whiteGold/safeBox/transferToIcon.png": 7583,
	"./yellowWhite/safeBox/transferToIcon.png": 51729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91833;